export type Tuple0							= readonly [];
export type Tuple1<T1>						= readonly [ T1 ];
export type Tuple2<T1, T2>					= readonly [ T1, T2 ];
export type Tuple3<T1, T2, T3>				= readonly [ T1, T2, T3 ];
export type Tuple4<T1, T2, T3, T4>			= readonly [ T1, T2, T3, T4 ];
export type Tuple5<T1, T2, T3, T4, T5>		= readonly [ T1, T2, T3, T4, T5 ];
export type Tuple6<T1, T2, T3, T4, T5, T6>	= readonly [ T1, T2, T3, T4, T5, T6 ];

export namespace Tuple {
	export const ofN	= <T extends ReadonlyArray<unknown>>(...args:T):Readonly<T>	=> args;

	/*
	export const of1		= <T0>(t0:T0):Tuple1<T0> => [ t0 ];
	export const of2		= <T0,T1>(t0:T0, t1:T1):Tuple2<T0,T1> => [ t0,t1 ];
	export const of3		= <T0,T1,T2>(t0:T0, t1:T1, t2:T2):Tuple3<T0,T1,T2> => [ t0,t1,t2 ];
	export const of4		= <T0,T1,T2,T3>(t0:T0, t1:T1, t2:T2, t3:T3):Tuple4<T0,T1,T2,T3> => [ t0,t1,t2,t3 ];
	export const of5		= <T0,T1,T2,T3,T4>(t0:T0, t1:T1, t2:T2, t3:T3, t4:T4):Tuple5<T0,T1,T2,T3,T4> => [ t0,t1,t2,t3,t4 ];
	export const of6		= <T0,T1,T2,T3,T4,T5>(t0:T0, t1:T1, t2:T2, t3:T3, t4:T4, t5:T5):Tuple6<T0,T1,T2,T3,T4,T5> => [ t0,t1,t2,t3,t4,t5 ];
	*/

	export type Prepend<A, B extends ReadonlyArray<unknown>>	= readonly [ A, ...B ];
	export const prepend	= <T extends ReadonlyArray<unknown>>(self:T) => <I>(item:I):Prepend<I, T>	=> [ item, ...self ];

	export type Append<A extends ReadonlyArray<unknown>, B>	= readonly [ ...A, B ];
	export const append		= <T extends ReadonlyArray<unknown>>(self:T) => <I>(item:I):Append<T, I>	=> [ ...self, item ];

	export type Concat<A extends ReadonlyArray<unknown>, B extends ReadonlyArray<unknown>>	= readonly [ ...A, ...B ];
	export const concat		= <T1 extends ReadonlyArray<unknown>, T2 extends ReadonlyArray<unknown>>(t1:T1, t2:T2):Concat<T1, T2>	=> [ ...t1, ...t2 ];

	export type Head<T extends ReadonlyArray<unknown>>	= T extends readonly [ infer X, ...ReadonlyArray<unknown> ] ? X : never;
	export type Tail<T extends ReadonlyArray<unknown>>	= T extends readonly [ unknown, ...(infer X) ] ? X : never;

	export type Last<T extends ReadonlyArray<unknown>>	= T extends readonly [ ...ReadonlyArray<unknown>, infer X ] ? X : never;
	export type Init<T extends ReadonlyArray<unknown>>	= T extends readonly [ ...(infer X), unknown ] ? X : never;

	export type Reverse<S> = S extends [ infer H, ...infer T ] ? [ ...Reverse<T>, H ] : [];
}
